module.exports = __webpack_public_path__ + "img/press-bg-1.e33a0fdb.svg";